<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre19" id="pgepubid00038"><span class="calibre1">CHAPTER II</span> <span class="smaller1">PETROGRAD</span></h2>
<p class="calibre7">My parents had moved to St. Petersburg when I was thirteen. Under the
discipline of a German school in Königsberg and the Prussian attitude
toward everything Russian, I had grown up in the atmosphere of hatred
to that country. I dreaded especially the terrible Nihilists who had
killed Tsar Alexander II, so good and kind, as I had been taught. St.
Petersburg was to me an evil thing. But the gayety of the city, its
vivacity and brilliancy, soon dispelled my childish fancies and made
the city appear like a fairy dream. Then my curiosity was aroused by
the revolutionary mystery which seemed to hang over everyone, and of
which no one dared to speak. When four years later I left with my
sister for America I was no longer the German Gretchen to whom Russia
spelt evil. My whole soul had been transformed and the seed planted for
what was to be my life's work. Especially did St. Petersburg <span id="pgepubid00039" title="[Pg 12]"><a id="Page_12" title="[Pg 12]"></a></span>remain in
my memory a vivid picture, full of life and mystery.</p>
<p class="calibre7">I found Petrograd of 1920 quite a different place. It was almost in
ruins, as if a hurricane had swept over it. The houses looked like
broken old tombs upon neglected and forgotten cemeteries. The streets
were dirty and deserted; all life had gone from them. The population
of Petrograd before the war was almost two million; in 1920 it had
dwindled to five hundred thousand. The people walked about like living
corpses; the shortage of food and fuel was slowly sapping the city;
grim death was clutching at its heart. Emaciated and frost-bitten men,
women, and children were being whipped by the common lash, the search
for a piece of bread or a stick of wood. It was a heart-rending sight
by day, an oppressive weight at night. Especially were the nights of
the first month in Petrograd dreadful. The utter stillness of the
large city was paralysing. It fairly haunted me, this awful oppressive
silence broken only by occasional shots. I would lay awake trying to
pierce the mystery. Did not Zorin say that capital punishment had been
abolished? Why this shooting? Doubts disturbed my mind, but I tried to
wave them aside. I had come to learn.</p>
<p class="calibre7"><span id="pgepubid00040" title="[Pg 13]"><a id="Page_13" title="[Pg 13]"></a></span></p>
<p class="calibre7">Much of my first knowledge and impressions of the October Revolution
and the events that followed I received from the Zorins. As already
mentioned, both had lived in America, spoke English, and were eager
to enlighten me upon the history of the Revolution. They were devoted
to the cause and worked very hard; he, especially, who was secretary
of the Petrograd committee of his party, besides editing the daily,
<i class="calibre18">Krasnaya Gazetta</i>, and participating in other activities.</p>
<p class="calibre7">It was from Zorin that I first learned about that legendary figure,
Makhno. The latter was an Anarchist, I was informed, who under the Tsar
had been sentenced to <i class="calibre18">katorga</i>. Liberated by the February revolution,
he became the leader of a peasant army in the Ukraina, proving himself
extremely able and daring and doing splendid work in the defence of the
Revolution. For some time Makhno worked in harmony with the Bolsheviki,
fighting the counter-revolutionary forces. Then he became antagonistic,
and now his army, recruited from bandit elements, was fighting the
Bolsheviki. Zorin related that he had been one of a committee sent to
Makhno to bring about an understanding. But Makhno would not listen
to reason. He continued his<span id="pgepubid00041" title="[Pg 14]"><a id="Page_14" title="[Pg 14]"></a></span> warfare against the Soviets and was
considered a dangerous counter-revolutionist.</p>
<p class="calibre7">I had no means of verifying the story, and I was far from disbelieving
the Zorins. Both appeared most sincere and dedicated to their work,
types of religious zealots ready to burn the heretic, but equally ready
to sacrifice their own lives for their cause. I was much impressed by
the simplicity of their lives. Holding a responsible position, Zorin
could have received special rations, but they lived very poorly, their
supper often consisting only of herring, black bread, and tea. I
thought it especially admirable because Lisa Zorin was with child at
the time.</p>
<p class="calibre7">Two weeks after my arrival in Russia I was invited to attend the
Alexander Herzen commemoration in the Winter Palace. The white marble
hall where the gathering took place seemed to intensify the bitter
frost, but the people present were unmindful of the penetrating cold. I
also was conscious only of the unique situation: Alexander Herzen, one
of the most hated revolutionists of his time, honoured in the Winter
Palace! Frequently before the spirit of Herzen had found its way into
the house of the Romanovs. It was when the "Kolokol," published abroad
and sparkling with the brilliancy of<span id="pgepubid00042" title="[Pg 15]"><a id="Page_15" title="[Pg 15]"></a></span> Herzen and Turgenev, would in
some mysterious manner be discovered on the desk of the Tsar. Now the
Tsars were no more, but the spirit of Herzen had risen again and was
witnessing the realization of the dream of one of Russia's great men.</p>
<p class="calibre7">One evening I was informed that Zinoviev had returned from Moscow and
would see me. He arrived about midnight. He looked very tired and was
constantly disturbed by urgent messages. Our talk was of a general
nature, of the grave situation in Russia, the shortage of food and fuel
then particularly poignant, and about the labour situation in America.
He was anxious to know "how soon the revolution could be expected in
the United States." He left upon me no definite impression, but I was
conscious of something lacking in the man, though I could not determine
at the time just what it was.</p>
<p class="calibre7">Another Communist I saw much of the first weeks was John Reed. I had
known him in America. He was living in the Astoria, working hard and
preparing for his return to the United States. He was to journey
through Latvia and he seemed apprehensive of the outcome. He had been
in Russia during the October days and this was his second visit. Like
Shatov he also<span id="pgepubid00043" title="[Pg 16]"><a id="Page_16" title="[Pg 16]"></a></span> insisted that the dark sides of the Bolshevik régime
were inevitable. He believed fervently that the Soviet Government
would emerge from its narrow party lines and that it would presently
establish the Communistic Commonwealth. We spent much time together,
discussing the various phases of the situation.</p>
<p class="calibre7">So far I had met none of the Anarchists and their failure to call
rather surprised me. One day a friend I had known in the States
came to inquire whether I would see several members of an Anarchist
organization. I readily assented. From them I learned a version of the
Russian Revolution and the Bolshevik régime utterly different from what
I had heard before. It was so startling, so terrible that I could not
believe it. They invited me to attend a small gathering they had called
to present to me their views.</p>
<p class="calibre7">The following Sunday I went to their conference. Passing Nevsky
Prospekt, near Liteiny Street, I came upon a group of women huddled
together to protect themselves from the cold. They were surrounded
by soldiers, talking and gesticulating. Those women, I learned, were
prostitutes who were selling themselves for a pound of bread, a piece
of soap or chocolate. The soldiers were the only ones who could
<span id="pgepubid00044" title="[Pg 17]"><a id="Page_17" title="[Pg 17]"></a></span>afford to buy them because of their extra rations. Prostitution in
revolutionary Russia. I wondered. What is the Communist Government
doing for these unfortunates? What are the Workers' and Peasants'
Soviets doing? My escort smiled sadly. The Soviet Government had closed
the houses of prostitution and was now trying to drive the women off
the streets, but hunger and cold drove them back again; besides,
the soldiers had to be humoured. It was too ghastly, too incredible
to be real, yet there they were—those shivering creatures for sale
and their buyers, the red defenders of the Revolution. "The cursed
interventionists, the blockade—they are responsible," said my escort.
Why, yes, the counter-revolutionists and the blockade are responsible,
I reassured myself. I tried to dismiss the thought of that huddled
group, but it clung to me. I felt something snap within me.</p>
<p class="calibre7">At last we reached the Anarchist quarters, in a dilapidated house
in a filthy backyard. I was ushered into a small room crowded with
men and women. The sight recalled pictures of thirty years ago when,
persecuted and hunted from place to place, the Anarchists in America
were compelled to meet in a dingy hall on Orchard Street, New York, or
in the dark rear room of a<span id="pgepubid00045" title="[Pg 18]"><a id="Page_18" title="[Pg 18]"></a></span> saloon. That was in capitalistic America.
But this is revolutionary Russia, which the Anarchists had helped to
free. Why should they have to gather in secret and in such a place?</p>
<p class="calibre7">That evening and the following day I listened to a recital of the
betrayal of the Revolution by the Bolsheviki. Workers from the Baltic
factories spoke of their enslavement, Kronstadt sailors voiced their
bitterness and indignation against the people they had helped to
power and who had become their masters. One of the speakers had been
condemned to death by the Bolsheviki for his Anarchist ideas, but had
escaped and was now living illegally. He related how the sailors had
been robbed of the freedom of their Soviets, how every breath of life
was being censored. Others spoke of the Red Terror and repression in
Moscow, which resulted in the throwing of a bomb into the gathering of
the Moscow section of the Communist Party in September, 1919. They told
me of the over-filled prisons, of the violence practised on the workers
and peasants. I listened rather impatiently, for everything in me cried
out against this indictment. It sounded impossible; it could not be.
Someone was surely at fault, but probably it was they, my comrades, I
thought. They were<span id="pgepubid00046" title="[Pg 19]"><a id="Page_19" title="[Pg 19]"></a></span> unreasonable, impatient for immediate results. Was
not violence inevitable in a revolution, and was it not imposed upon
the Bolsheviki by the Interventionists? My comrades were indignant.
"Disguise yourself so the Bolsheviki do not recognize you; take a
pamphlet of Kropotkin and try to distribute it in a Soviet meeting. You
will soon see whether we told you the truth. Above all, get out of the
First House of the Soviet. Live among the people and you will have all
the proofs you need."</p>
<p class="calibre7">How childish and trifling it all seemed in the face of the world event
that was taking place in Russia! No, I could not credit their stories.
I would wait and study conditions. But my mind was in a turmoil, and
the nights became more oppressive than ever.</p>
<p class="calibre7">The day arrived when I was given a chance to attend the meeting of
the Petro-Soviet. It was to be a double celebration in honour of the
return of Karl Radek to Russia and Joffe's report on the peace treaty
with Esthonia. As usual I went with the Zorins. The gathering was in
the Tauride Palace, the former meeting place of the Russian Duma. Every
entrance to the hall was guarded by soldiers, the platform surrounded
by them holding their guns at attention.<span id="pgepubid00047" title="[Pg 20]"><a id="Page_20" title="[Pg 20]"></a></span> The hall was crowded to the
very doors. I was on the platform overlooking the sea of faces below.
Starved and wretched they looked, these sons and daughters of the
people, the heroes of Red Petrograd. How they had suffered and endured
for the Revolution! I felt very humble before them.</p>
<p class="calibre7">Zinoviev presided. After the "Internationale" had been sung by the
audience standing, Zinoviev opened the meeting. He spoke at length.
His voice is high pitched, without depth. The moment I heard him I
realized what I had missed in him at our first meeting—depth, strength
of character. Next came Radek. He was clever, witty, sarcastic, and
he paid his respects to the counter-revolutionists and to the White
Guards. Altogether an interesting man and an interesting address.</p>
<p class="calibre7">Joffe looked the diplomat. Well fed and groomed, he seemed rather
out of place in that assembly. He spoke of the peace conditions
with Esthonia, which were received with enthusiasm by the audience.
Certainly these people wanted peace. Would it ever come to Russia?</p>
<p class="calibre7">Last spoke Zorin, by far the ablest and most convincing that evening.
Then the meeting<span id="pgepubid00048" title="[Pg 21]"><a id="Page_21" title="[Pg 21]"></a></span> was thrown open to discussion. A Menshevik asked for
the floor. Immediately pandemonium broke loose. Yells of "Traitor!"
"Kolchak!" "Counter-Revolutionist!" came from all parts of the audience
and even from the platform. It looked to me like an unworthy proceeding
for a revolutionary assembly.</p>
<p class="calibre7">On the way home I spoke to Zorin about it. He laughed. "Free speech
is a bourgeois superstition," he said; "during a revolutionary period
there can be no free speech." I was rather dubious about the sweeping
statement, but I felt that I had no right to judge. I was a newcomer,
while the people at the Tauride Palace had sacrificed and suffered so
much for the Revolution. I had no right to judge.</p>
<p class="calibre7"><span id="pgepubid00049" title="[Pg 22]"><a id="Page_22" title="[Pg 22]"></a></span></p>
<div class="calibre23" id="calibre_pb_7"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?0fb0878b